import React, { useState, useEffect } from 'react';
import intl from 'react-intl-universal';
import { useNavigate } from 'react-router-dom';

import { RightOutline, DownOutline } from 'antd-mobile-icons'
import { Image } from 'antd-mobile';
import { getScopeParam } from '../../utils/session/store'
import { formatJSON, replaceCDNDomain } from '../../utils';

import CouponType from '../coupons/CouponList/CouponType';

import styles from '../coupons/CouponList/index.module.less';
import { getReachCanUseText, getDiscountDisplay, getExpiredText } from '../../utils/coupon';


const CouponBox = ({ list = [], relateArea = '', products = [], showNumber = false }) => {
    const navigate = useNavigate()
    const scopeParam = getScopeParam()

    const [couponList, setCouponList] = useState(list)


    const setShowRule = (coupon) => {
        coupon.showRule = !coupon.showRule
        setCouponList([...couponList])
    }

    useEffect(() => {
        setCouponList(list)
    }, [list])

    return (
        <div className={styles.myCouponContainer}>
            {couponList.map((coupon, index) => {
                const { useRule, couponRuleSourceParam4, couponData } = coupon;
                const ruleStr = (formatJSON(useRule)?.briefDesc || '');
                const dataObj = formatJSON(couponData)

                // 有效期
                const validDate = getExpiredText(coupon);

                let isOffline = false
                if (couponRuleSourceParam4) {
                    const ruleObj = formatJSON(couponRuleSourceParam4) || {};
                    isOffline = ruleObj.couponUseWay === 2;
                }


                return (
                    <div key={index} className={`${styles.couponCard} ${coupon.couponState === 3 ? styles.couponExpired : ''}`}>

                        {/* 主体信息区 */}
                        <div className={styles.couponBody}>
                            <div className={styles.couponTitle}>{coupon.couponName}</div>
                            <div className={`${styles.couponRuleTitle} jm-flex`} onClick={() => {
                                setShowRule(coupon)
                            }}>
                                <div className='jm-flex-item'>{intl.get('h_detail').d('详情')}</div>
                                <div>{coupon.showRule ? <DownOutline fontSize={14} /> : <RightOutline fontSize={14} />}</div>
                            </div>
                            <div className={styles.useRuleBox} style={{ display: coupon.showRule ? 'block' : 'none' }}>
                                {
                                    showNumber
                                        ?
                                        <>
                                            {
                                                products.map((product, index) => {
                                                    const { extendColumn2 } = product
                                                    const extendObj = formatJSON(extendColumn2) || {}
                                                    const { couponNums } = extendObj
                                                    return (
                                                        <div key={index}>
                                                            <div className='text-center' style={{wordBreak:'break-word'}}><h2>{couponNums}</h2></div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </>
                                        :
                                        <>
                                            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 5 }}>
                                                <Image src={replaceCDNDomain(dataObj.qrcode)} style={{ width: '50%', height: 'auto' }} />
                                            </div>
                                            <div className='text-center'><h2>{coupon.couponNum}</h2></div>
                                        </>
                                }

                                <div
                                    className={styles.couponDesc}
                                    dangerouslySetInnerHTML={{ __html: ruleStr }}
                                    style={{ lineHeight: 1.3 }}>
                                </div>
                                <div className={styles.couponValid}>{intl.get('valid_period').d('有效期')}:{validDate}</div>
                            </div>


                            {/* <div className={styles.couponLimit}>{coupon.limitDesc || <>&nbsp;</>}</div> */}
                            {
                                coupon.couponState === 3 && (<div className={styles.expiredBlock}>{intl.get('expired').d('已过期')}</div>)
                            }
                        </div>

                    </div>
                );
            })}
        </div>
    );
};

export default CouponBox;